export default __webpack_public_path__ + "static/ods-38f6efb072ab6c4177dc184294d95888.png";